<script>
	import { createSurveyColors } from "$lib/data/surveyIcons";
	export let rating = 1;
	export let color = "rgba(0, 0, 0, 0.5)";
	const colors = createSurveyColors();
</script>

<div class="{$$props.class ?? ''} smiley-cover">
	{#if rating === 1}
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 48 48"
			fill="{colors[0]}"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M41.6635 34.337L41.662 34.3395L41.6607 34.3418C39.9865 37.4142 37.451 39.9961 34.4791 41.6406C31.5191 43.2784 28.029 44 24.4832 44C20.96 44 17.4482 43.2615 14.1734 41.7206C11.0116 40.1965 8.57929 37.8931 6.66112 34.792L6.65865 34.7879L6.65617 34.784C4.77175 31.7735 3.89619 27.9936 4.00978 24.2228C4.15403 20.2784 4.77723 16.6394 6.60627 13.5561L6.60866 13.5521L6.61103 13.5481C8.43791 10.4309 11.0866 8.18828 14.2462 6.49136C17.3778 4.80941 20.8715 3.89357 24.3538 4.00988H24.3541C28.0233 4.13165 31.4756 4.81977 34.509 6.48414C37.5287 8.14094 39.844 10.6076 41.5318 13.6805C43.2011 16.7452 44.0432 20.3762 43.9983 24.0326C43.9266 27.7908 43.3001 31.3561 41.6635 34.337Z"
				class="outer-path"
				stroke="{color}"
				stroke-width="1.1"></path>
			<path
				d="M18 33C18.6676 32.3488 19.5808 31.849 20.6155 31.5127C21.6565 31.1742 22.8226 31 24 31C25.1774 31 26.3436 31.1742 27.3846 31.5127C28.4192 31.849 29.3325 32.3488 30 33"
				stroke="{color}"
				stroke-width="1.5"
				shape-rendering="geometricPrecision"
				stroke-linecap="round"></path>
			<path
				d="M21.2536 25.309C21.2536 25.309 20.96 25.1015 19 24.5C17.04 23.8985 16 23.916 16 23.916"
				stroke="{color}"
				stroke-width="1.5"
				shape-rendering="geometricPrecision"
				stroke-linecap="round"></path>
			<path
				d="M31.2255 23.951C31.2255 23.951 30.5 24.049 28.5 24.5C26.5 24.951 25.9735 25.3502 25.9735 25.3502"
				stroke="{color}"
				stroke-width="1.5"
				shape-rendering="geometricPrecision"
				stroke-linecap="round"></path>
		</svg>
	{:else if rating === 2}
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 48 48"
			fill="{colors[1]}"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M41.6635 34.337L41.662 34.3395L41.6607 34.3418C39.9865 37.4142 37.451 39.9961 34.4791 41.6406C31.5191 43.2784 28.029 44 24.4832 44C20.96 44 17.4482 43.2615 14.1734 41.7206C11.0116 40.1965 8.57929 37.8931 6.66112 34.792L6.65865 34.7879L6.65617 34.784C4.77175 31.7735 3.89619 27.9936 4.00978 24.2228C4.15403 20.2784 4.77723 16.6394 6.60627 13.5561L6.60866 13.5521L6.61103 13.5481C8.43791 10.4309 11.0866 8.18828 14.2462 6.49136C17.3778 4.80941 20.8715 3.89357 24.3538 4.00988H24.3541C28.0233 4.13165 31.4756 4.81977 34.509 6.48414C37.5287 8.14094 39.844 10.6076 41.5318 13.6805C43.2011 16.7452 44.0432 20.3762 43.9983 24.0326C43.9266 27.7908 43.3001 31.3561 41.6635 34.337Z"
				class="outer-path"
				stroke="{color}"
				stroke-width="1.1"></path>
			<circle cx="16" cy="23" r="2" fill="{color}"></circle>
			<circle cx="32" cy="23" r="2" fill="{color}"></circle>
			<path
				d="M17 32.1828C17 32.1828 19.4546 32.5 21.5 33.5C23.5 34.4778 24 35 24 35"
				stroke="{color}"
				stroke-width="1.5"
				stroke-linecap="round"></path>
		</svg>
	{:else if rating === 3}
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 48 48"
			fill="{colors[2]}"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M41.6635 34.337L41.662 34.3395L41.6607 34.3418C39.9865 37.4142 37.451 39.9961 34.4791 41.6406C31.5191 43.2784 28.029 44 24.4832 44C20.96 44 17.4482 43.2615 14.1734 41.7206C11.0116 40.1965 8.57929 37.8931 6.66112 34.792L6.65865 34.7879L6.65617 34.784C4.77175 31.7735 3.89619 27.9936 4.00978 24.2228C4.15403 20.2784 4.77723 16.6394 6.60627 13.5561L6.60866 13.5521L6.61103 13.5481C8.43791 10.4309 11.0866 8.18828 14.2462 6.49136C17.3778 4.80941 20.8715 3.89357 24.3538 4.00988H24.3541C28.0233 4.13165 31.4756 4.81977 34.509 6.48414C37.5287 8.14094 39.844 10.6076 41.5318 13.6805C43.2011 16.7452 44.0432 20.3762 43.9983 24.0326C43.9266 27.7908 43.3001 31.3561 41.6635 34.337Z"
				stroke="{color}"
				class="outer-path"
				stroke-width="1.1"></path>
			<path
				d="M18 37L30 37"
				stroke="{color}"
				stroke-width="1.5"
				stroke-linecap="round"></path>
			<circle cx="13" cy="27" r="1.75" fill="{color}"></circle>
			<circle cx="35" cy="27" r="1.75" fill="{color}"></circle>
		</svg>
	{:else if rating === 4}
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 48 48"
			fill="{colors[3]}"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M41.6635 34.337L41.662 34.3395L41.6607 34.3418C39.9865 37.4142 37.451 39.9961 34.4791 41.6406C31.5191 43.2784 28.029 44 24.4832 44C20.96 44 17.4482 43.2615 14.1734 41.7206C11.0116 40.1965 8.57929 37.8931 6.66112 34.792L6.65865 34.7879L6.65617 34.784C4.77175 31.7735 3.89619 27.9936 4.00978 24.2228C4.15403 20.2784 4.77723 16.6394 6.60627 13.5561L6.60866 13.5521L6.61103 13.5481C8.43791 10.4309 11.0866 8.18828 14.2462 6.49136C17.3778 4.80941 20.8715 3.89357 24.3538 4.00988H24.3541C28.0233 4.13165 31.4756 4.81977 34.509 6.48414C37.5287 8.14094 39.844 10.6076 41.5318 13.6805C43.2011 16.7452 44.0432 20.3762 43.9983 24.0326C43.9266 27.7908 43.3001 31.3561 41.6635 34.337Z"
				stroke="{color}"
				class="outer-path"
				stroke-width="1.1"></path>
			<circle cx="12" cy="26" r="2" fill="{color}"></circle>
			<circle cx="36" cy="26" r="2" fill="{color}"></circle>
			<path
				d="M21.7204 35.5982C21.7204 35.5982 23.4878 36.4145 26.9922 35.627C30.4965 34.8395 31.2799 32.7212 31.2799 32.7212"
				stroke="{color}"
				stroke-width="1.5"
				stroke-linecap="round"></path>
		</svg>
	{:else}
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 48 48"
			fill="{colors[4]}"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M41.6635 34.337L41.662 34.3395L41.6607 34.3418C39.9865 37.4142 37.451 39.9961 34.4791 41.6406C31.5191 43.2784 28.029 44 24.4832 44C20.96 44 17.4482 43.2615 14.1734 41.7206C11.0116 40.1965 8.57929 37.8931 6.66112 34.792L6.65865 34.7879L6.65617 34.784C4.77175 31.7735 3.89619 27.9936 4.00978 24.2228C4.15403 20.2784 4.77723 16.6394 6.60627 13.5561L6.60866 13.5521L6.61103 13.5481C8.43791 10.4309 11.0866 8.18828 14.2462 6.49136C17.3778 4.80941 20.8715 3.89357 24.3538 4.00988H24.3541C28.0233 4.13165 31.4756 4.81977 34.509 6.48414C37.5287 8.14094 39.844 10.6076 41.5318 13.6805C43.2011 16.7452 44.0432 20.3762 43.9983 24.0326C43.9266 27.7908 43.3001 31.3561 41.6635 34.337Z"
				stroke="{color}"
				class="outer-path"
				stroke-width="1.1"></path>
			<path
				d="M31 34C30.2211 34.6512 29.1557 35.151 27.9485 35.4873C26.7341 35.8259 25.3736 36 24 36C22.6263 36 21.2658 35.8259 20.0513 35.4873C18.8443 35.151 17.7788 34.6512 17 34"
				stroke="{color}"
				stroke-width="1.5"
				stroke-linecap="round"></path>
			<path
				d="M16.4944 21.7112C15.0041 21.9501 14.3443 22.5207 14.0648 23.0621C13.7775 23.6182 14.6035 24.0084 15.3107 23.7891C15.9032 23.6054 16.5908 23.4194 17.1725 23.3346C17.6937 23.2587 18.3493 23.2323 18.9446 23.2276C19.7413 23.2214 20.2295 22.6139 19.5852 22.1956C18.9585 21.7887 17.9769 21.4736 16.4944 21.7112Z"
				fill="{color}"></path>
			<path
				d="M30.7347 21.7328C32.2266 21.981 32.6516 22.4974 32.933 23.0498C33.2223 23.6172 32.3971 24.0119 31.6888 23.7862C31.0953 23.5972 30.4067 23.4054 29.8244 23.3172C29.3027 23.2382 28.6466 23.2091 28.051 23.2024C27.2538 23.1934 26.7633 22.5731 27.4066 22.1491C28.0324 21.7368 29.2506 21.4859 30.7347 21.7328Z"
				fill="{color}"></path>
		</svg>
	{/if}
</div>
